import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import "./banner.css";

const Banner = () => {
  return (
    <div>
      <Container fluid className="loyalty-wrapper">
        <motion.div
          className="loyalty-card"
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <Row className="align-items-center">
            {/* LEFT CONTENT */}
            <Col lg={6} md={7} sm={12} className="text-section">
              <motion.h1
                initial={{ opacity: 0, x: -40 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3, duration: 0.6 }}
              >
                Be a member of our <br />
                <span className="bold-text">Loyalty Program.</span> <br />
                Avail benefits. Get discounts.
              </motion.h1>

              <NavLink to="/aboutus">
                <motion.div
                  whileHover={{ x: 8 }}
                  transition={{ type: "spring", stiffness: 200 }}
                  className="know-more p-5"
                >
                  Know More →
                </motion.div>
              </NavLink>
            </Col>

            {/* RIGHT IMAGE */}
            <Col lg={6} md={5} sm={12} className="image-section">
              <motion.img
                src="/images/banner.webp" // put your image here
                alt="iPhones"
                className="phone-img"
                initial={{ opacity: 0, x: 80 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              />
            </Col>
          </Row>
        </motion.div>
      </Container>
    </div>
  );
};

export default Banner;
